import { PersistentStoreName } from 'stores/_utils/persistentStore/persistenceStoresCleanUpMap'
import { persistentInit } from '../_utils/persistentStore/persistentStore'

export type TFeedbackEventStore = {
  views: Set<string>
  feedback: Record<string, 'like' | 'dislike' | null>
}

export const feedbackEventStore = persistentInit<TFeedbackEventStore>({
  initialState: {
    views: new Set<string>(),
    feedback: {},
  },
  keysToPutInURL: {
    views: false,
    feedback: false,
  },
  keysToPutInPersistentStorage: {
    views: false,
    feedback: false,
  },
  storeName: PersistentStoreName.FEEDBACK_EVENT_STORE,
})
